import { BpIdUserDto } from "@libs/api/gateways/bp-id/bp-id.dtos";

export const getBpIdUserName = (user: BpIdUserDto) =>
  user.displayName || `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
